import { render, staticRenderFns } from "./TrailerIcon.vue?vue&type=template&id=24cdf9aa&scoped=true&"
import script from "./TrailerIcon.vue?vue&type=script&lang=js&"
export * from "./TrailerIcon.vue?vue&type=script&lang=js&"
import style0 from "./TrailerIcon.vue?vue&type=style&index=0&id=24cdf9aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cdf9aa",
  null
  
)

export default component.exports